import { render } from "./SectionsWorkPlan.vue?vue&type=template&id=abb3a6ce"
import script from "./SectionsWorkPlan.vue?vue&type=script&lang=js"
export * from "./SectionsWorkPlan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__